<template>
  <cv-header-nav aria-label="Conto Terzi Navigazione Alto">
    <MenuLavori v-bind:autoapertura="true"/>
    <MenuContabilita v-bind:autoapertura="true"/>
    <MenuMovimenti v-bind:autoapertura="true"/>
    <MenuDitte v-bind:autoapertura="true" />
    <MenuPosizioni v-bind:autoapertura="true" />
  </cv-header-nav>
</template>

<script>
import MenuLavori from "@/components/menu/MenuLavori";
import MenuContabilita from "@/components/menu/MenuContabilita";
import MenuMovimenti from "@/components/menu/MenuMovimenti";
import MenuDitte from "@/components/menu/MenuDitte";
import MenuPosizioni from "@/components/menu/MenuPosizioni";

export default {
  name: "MenuAlto",
  components: {
    MenuMovimenti,
    MenuLavori,
    MenuContabilita,
    MenuDitte,
    MenuPosizioni
  }
}
</script>

<style scoped>

</style>